module.exports = __webpack_public_path__ + "static/media/empty-users.38f36390.svg";